module.exports = __webpack_public_path__ + "static/img/1.df21ad1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/sp/1.png
// module id = qmrD
// module chunks = 0